//@ts-nocheck
import { useEffect, useState } from "react";

export const useWebOTPApi = (): string => {
  const [code, setCode] = useState("");

  useEffect(() => {
    if ("OTPCredential" in window) {
      const abortController = new AbortController();
      const timer = setTimeout(() => {
        abortController.abort();
      }, 10 * 1000);

      const handleOTPcode = () => {
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: abortController.signal,
          })
          .then(otp => {
            setCode(otp?.code || "");
          })
          .catch(err => {
            console.log(err);
          });
      };

      window.addEventListener("DOMContentLoaded", handleOTPcode);
      return () => {
        window.removeEventListener("DOMContentLoaded", handleOTPcode);
        if (timer) {
          clearTimeout(timer);
        }
      };
    }
  }, []);

  return code;
};
